var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{attrs:{"name":"fade-arquivos"}},_vm._l((_vm.listaArquivos),function(arquivo){return _c('ArquivoBase',{key:arquivo.objetoArquivo.id,attrs:{"tipoArquivo":arquivo.tipoArquivo,"objetoArquivo":arquivo.objetoArquivo,"barraProgresso":arquivo.barraProgresso},on:{"baixar-arquivo":uuid => _vm.$emit('baixar-arquivo', uuid)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }